import React from 'react';
import { getLearningPackages } from '../data/learningCycleData';

const LearningPackagesPage = ({ language = 'traditional', onBack, onViewAIFeedback, onViewCertifiedCourses }) => {
  const packages = getLearningPackages();

  const getText = (textObj) => {
    return textObj[language] || textObj.traditional;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 text-white">
      {/* Header */}
      <div className="px-6 py-6">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-xl font-bold text-center flex-1">
            {getText({ traditional: '選擇適合你的ELSA 學習套餐', simplified: '选择适合你的ELSA 学习套餐', english: 'Choose the ELSA learning package that suits you' })}
          </h1>
          <button onClick={onBack} className="text-white text-xl ml-4">
            ✕
          </button>
        </div>

        {/* Comparison Table */}
        <div className="bg-gray-800/30 border border-gray-600 rounded-xl p-4 mb-6">
          <div className="grid grid-cols-3 gap-4 mb-4">
            <div className="text-center font-semibold text-gray-300">
              {getText({ traditional: '學習套餐', simplified: '学习套餐', english: 'Learning Package' })}
            </div>
            <div className="text-center font-semibold text-gray-300">
              {getText(packages.free.name)}
            </div>
            <div className="text-center font-semibold text-gray-300">
              {getText(packages.premium.name)}
            </div>
          </div>

          {/* Features */}
          <div className="space-y-3">
            {packages.free.features.map((feature, index) => (
              <div key={index} className="grid grid-cols-3 gap-4 items-center py-2 border-b border-gray-600 last:border-b-0">
                <div className="text-sm text-gray-300">
                  {getText(feature.name)}
                </div>
                <div className={`text-center text-sm ${feature.available ? 'text-green-400' : 'text-red-400'}`}>
                  {getText(feature.status)}
                </div>
                <div className={`text-center text-sm ${packages.premium.features[index].available ? 'text-green-400' : 'text-red-400'}`}>
                  {getText(packages.premium.features[index].status)}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Action Buttons */}
        <div className="space-y-4">
          <button
            onClick={onViewAIFeedback}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-4 px-6 rounded-lg transition-colors"
          >
            {getText({ traditional: '查看 AI 反饋系統', simplified: '查看 AI 反馈系统', english: 'View AI Feedback System' })}
          </button>
          
          <button
            onClick={onViewCertifiedCourses}
            className="w-full bg-purple-600 hover:bg-purple-700 text-white font-semibold py-4 px-6 rounded-lg transition-colors"
          >
            {getText({ traditional: '查看認證課程', simplified: '查看认证课程', english: 'View Certified Courses' })}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LearningPackagesPage;
